module.exports = __webpack_public_path__ + "media/images/dd-7f03417f6caab51d27411909772904c2.webp";